<template>
    <b-modal id="requisition_delete" ref="requisition_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.requisition.data.attributes.item + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('requisition_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteRequisition">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../components/Common/StateButton";

export default {
    name: "RequisitionDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'requisition'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteRequisition() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteRequisition', this.requisition)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-requisition');

                            this.$notify('error filled', 'Success!', 'Deleted the requisition!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('requisition_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
